import { Suspense, ComponentType, ReactNode } from 'react';

// project imports
import TabPanelSkeleton from 'ui-component/tabs/TabPanelSkeleton';

export type LoadableOptions = {
  /** ברירת מחדל: Skeleton בשטח התוכן (לא מסך מלא) — כדי שניווט יישאר זמין בזמן טעינת chunk */
  suspenseFallback?: ReactNode;
};

export default function Loadable<P extends object>(Component: ComponentType<P>, options?: LoadableOptions) {
  const fallback = options?.suspenseFallback ?? <TabPanelSkeleton />;
  const WrappedComponent = (props: P) => (
    <Suspense fallback={fallback}>
      <Component {...props} />
    </Suspense>
  );

  return WrappedComponent;
}
